/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ConfirmStatusChangeModal from "../../components/modal/ConfirmStatusChangeModal";
import WithdrawRequestTable from "../../components/tables/WithdrawRequestTable";
import { postApiCaller } from "../../libs/apiCaller";
import { useUnauthorizedNavigation } from "../../libs/UnauthorisedPage";

const WithdrawRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [withdrawStatusChangeModalOpen, setWithdrawStatusChangeModalOpen] =
    useState(false);
  const [withdrawRequestList, setWithdrawRequestList] = useState([]);
  const [statusFlag, setStatusFlag] = useState({
    status: "",
    id: "",
    confirmStatus: "",
  });
  const redirectToLogin = useUnauthorizedNavigation();

  useEffect(() => {
    getWithdrawRequestData();
  }, []);

  const getWithdrawRequestData = async () => {
    setIsLoading(true);
    const endPoint = `withdraw_request_list`;
    const response = await postApiCaller(endPoint, {});
    if (response?.data?.response_code === 200) {
      setWithdrawRequestList(response?.data?.response_data);
    } else if (response.response.data.response_code === 403) {
      redirectToLogin();
    }
    setIsLoading(false);
  };

  const handleConfirmChangeStatus = async () => {
    setIsConfirmLoading(true);
    const endPoint = `withdraw_request_update`;
    const payload = {
      transaction_id: statusFlag.id,
      status: statusFlag.confirmStatus,
    };
    const response = await postApiCaller(endPoint, payload);
    if (response?.data?.response_code === 200) {
      toast.success(response?.data.response_message);
      await getWithdrawRequestData();
      setWithdrawStatusChangeModalOpen(false);
    } else if (response.response.data.response_code === 403) {
      redirectToLogin();
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="px-4 md:px-10">
        <div className="border border-1 px-4 py-3 rounded-t-2xl mt-4 bg-white">
          <p className="text-[#284184] font-bold text-xl">Withdraw Request</p>
        </div>
        <div className="border px-4 py-3 rounded-b-2xl text-xl bg-white">
          <WithdrawRequestTable
            isLoading={isLoading}
            withdrawRequestList={withdrawRequestList}
            setWithdrawStatusChangeModalOpen={setWithdrawStatusChangeModalOpen}
            setStatusFlag={setStatusFlag}
          />
        </div>
      </div>
      <ConfirmStatusChangeModal
        isOpen={withdrawStatusChangeModalOpen}
        onClose={() => setWithdrawStatusChangeModalOpen(false)}
        loading={isConfirmLoading}
        statusFlag={statusFlag}
        handleConfirmChangeStatus={handleConfirmChangeStatus}
      />
    </>
  );
};

export default WithdrawRequest;
